module.exports = "/images/content-img-3.jpg?ca080c4ca13369c4389e98ce836b4ba2";